import type { PageData } from '../../../../_metronic/helpers/utils/types';

export const blogData: PageData = [
  {
    formId: 'form1',
    heading: 'Blog Section',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' },
      { id: 'label', label: 'Text for blog links', type: 'input' }
    ]
  },
  {
    formId: 'form2',
    heading: 'Blog Detail Section',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' },
      { id: 'title', label: 'Title for More blogs', type: 'input' },
      { id: 'label', label: 'Text for blog links', type: 'input' },
      { id: 'update', label: 'Text for updated', type: 'input' }
    ]
  }
];
